import { Card, CardContent } from '@/components/ui/card';
import { useRetailerWorkspace } from './RetailerWorkspaceContext';

interface OverviewSectionProps {
  onEditRetailer: () => void;
  onArchiveRetailer: () => void;
}

export function OverviewSection(_props: OverviewSectionProps) {
  const { activeRetailer } = useRetailerWorkspace();

  if (!activeRetailer) {
    return (
      <Card>
        <CardContent className="py-12 text-center text-muted-foreground">
          Select a retailer to view its workspace.
        </CardContent>
      </Card>
    );
  }

  return (
    <Card>
      <CardContent className="space-y-2 pt-6">
        <p className="text-sm text-muted-foreground">
          {activeRetailer.description || 'No description provided.'}
        </p>
        <p className="text-sm text-muted-foreground">
          Use the workspace navigation to manage stores, media configuration, and operations
          for this retailer. Retailer create/archive/delete remain platform-level actions.
        </p>
      </CardContent>
    </Card>
  );
}
